import { render, staticRenderFns } from "./editpengajuan.vue?vue&type=template&id=46559138&"
import script from "./editpengajuan.vue?vue&type=script&lang=js&"
export * from "./editpengajuan.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports